// draggableNode.js
// Clean, professional draggable nodes

export const DraggableNode = ({ type, label }) => {
  const onDragStart = (event, nodeType) => {
    const appData = { nodeType };
    event.dataTransfer.setData(
      "application/reactflow",
      JSON.stringify(appData)
    );
    event.dataTransfer.effectAllowed = "move";
  };

  const nodeStyle = {
    cursor: "grab",
    padding: "10px 14px",
    minHeight: "44px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "6px",
    background: "#f8fafc",
    border: "1px solid #e2e8f0",
    color: "#475569",
    fontSize: "13px",
    fontWeight: "500",
    transition: "all 0.15s ease",
    userSelect: "none",
  };

  const handleMouseEnter = (e) => {
    e.currentTarget.style.background = "#ffffff";
    e.currentTarget.style.borderColor = "#cbd5e1";
    e.currentTarget.style.boxShadow = "0 1px 3px rgba(0, 0, 0, 0.06)";
  };

  const handleMouseLeave = (e) => {
    e.currentTarget.style.background = "#f8fafc";
    e.currentTarget.style.borderColor = "#e2e8f0";
    e.currentTarget.style.boxShadow = "none";
  };

  const handleMouseDown = (e) => {
    e.currentTarget.style.cursor = "grabbing";
  };

  const handleMouseUp = (e) => {
    e.currentTarget.style.cursor = "grab";
  };

  return (
    <div
      className={type}
      onDragStart={(event) => onDragStart(event, type)}
      onDragEnd={(event) => (event.target.style.cursor = "grab")}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onMouseDown={handleMouseDown}
      onMouseUp={handleMouseUp}
      style={nodeStyle}
      draggable
    >
      <span>{label}</span>
    </div>
  );
};
